import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Avatar,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { HHNTheme } from "hhn-commons";

export const Form = styled(FormControl)`
  padding: 16px;
  display: flex;
`;

export const HelperText = styled(FormHelperText)`
  color: ${HHNTheme.error};
  margin-bottom: 20px;
`;

export const SubmitButton = styled(Button)`
  margin: 8px 0 8px 12px;
`;

export const InputField = styled(TextField)`
  width: 100%;
  margin-bottom: 20px;
`;

export const ProfilePicture = styled(Avatar)`
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
`;

export const AddInternalInfoLayout = styled(Box)`
  flex-direction: column;
  margin-top: 20px;
`;
